<template>
    <div>
        <v-select
                :items="variants"
                item-text="name"
                item-value="id"
                label="Select a variant"
                v-model="selectedVariant"
                @change="updateImage"
        ></v-select>
        <v-img
                v-if="selectedVariant"
                :src="selectedVariant.preSignedUrl"
                max-width="400"
                class="mt-4"
        ></v-img>
    </div>
</template>

<script>
    export default {
        name: "DisplayVariants",
        props: {
            variants: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                selectedVariant: null
            };
        },
        methods: {
            updateImage(variantId) {
                this.selectedVariant = this.variants.find(
                    variant => variant.id === variantId
                );
            }
        }
    };
</script>

<style scoped>
</style>
